var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgXIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "X_Icon",
    "data-name": "X Icon",
    transform: "translate(11119 -12133)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "A-Icon-Container-24",
    transform: "translate(-11119 12133)",
    opacity: 0
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_446",
    "data-name": "Ellipse 446",
    transform: "translate(1 1)",
    fill: "none",
    stroke: "#3b61eb",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 11,
    r: 11,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 11,
    r: 10.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_16932",
    "data-name": "Group 16932",
    transform: "translate(-495 -316)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_9726",
    "data-name": "Rectangle 9726",
    transform: "translate(495 316)",
    fill: "none",
    stroke: "#3b61eb",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 23,
    height: 23,
    fill: "none"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9727",
    "data-name": "Rectangle 9727",
    width: 1,
    height: 32.357,
    transform: "translate(517.994 316.355) rotate(45)",
    fill: "#3b61eb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9728",
    "data-name": "Rectangle 9728",
    width: 1,
    height: 31.835,
    transform: "translate(495.066 316.92) rotate(-45)",
    fill: "#3b61eb"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_18511",
    "data-name": "Group 18511",
    transform: "translate(-11825 11968)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8217",
    "data-name": "Rectangle 8217",
    width: 16,
    height: 16,
    transform: "translate(710 169)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_14693",
    "data-name": "Group 14693",
    transform: "translate(712 171)",
    stroke: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11565",
    "data-name": "Path 11565",
    d: "M101,86.988l-13,13",
    transform: "translate(-88.5 -87.488)",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11566",
    "data-name": "Path 11566",
    d: "M87,86.988l13,13",
    transform: "translate(-87.5 -87.488)",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgXIcon);
export default __webpack_public_path__ + "static/media/x-icon.340c0af4f972fe3d4831c1a309016481.svg";
export { ForwardRef as ReactComponent };